import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  IfFeatureActiveDirective,
  IfPermissionEnabledDirective,
} from './directives';
import { FeatureControlGuard } from './guards';
import {
  FeatureControlRestConnectorService,
  FeatureControlService,
} from './services';
import { FeatureControlEffects, featureControlReducer } from './state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('featureControl', featureControlReducer),
    EffectsModule.forFeature([FeatureControlEffects]),
  ],
  declarations: [
    IfFeatureActiveDirective,
    IfPermissionEnabledDirective,
  ],
  exports: [
    IfFeatureActiveDirective,
    IfPermissionEnabledDirective,
  ],
  providers: [
    FeatureControlService,
    FeatureControlRestConnectorService,
    FeatureControlGuard,
  ],
})
export class FeatureControlModule {}
